import React from 'react'
import { sendGeneralRequest } from '../../features/generalRequest'
import Iframe from 'react-iframe'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import colors from '../colors'
import {Grid, Button} from '@mui/material';
import { texts } from './texts';
import { setGeneralMessage } from '../../features/global/globalDataSlice';
import { setShouldBasicAccountPaymentRun } from '../../features/basicAccount/basicAccountSlice';

const getErrorMessage = (url) => 
{
    const params = new Proxy(new URLSearchParams(url), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    if(params.errorMsg !== '')
    {
        return window.atob(params.errorMsg)
    }
    else
    {
        return texts["message-general-error"] 
    }      
} 

const checkBasicAccountPayment = (redirectUrl, dispatch, onSuccessRequest, onFailureRequest) => 
{
    if(redirectUrl.toLowerCase().includes("success"))
    {
        dispatch(sendGeneralRequest(onSuccessRequest))
    }
    else if(redirectUrl.toLowerCase().includes("fail"))
    {
        dispatch(setGeneralMessage({type: "error",message: getErrorMessage(redirectUrl)}))
        dispatch(setShouldBasicAccountPaymentRun(false))
    }
}

const handleBackButtonClick = (onBack) => 
{
    onBack()
}

export const runBasicAccountPayment = (dispatch, url, onSuccessRequest, onFailureRequest, onBack) => 
{
    return <Grid container justifyContent={'center'} direction={'column'}>
                <Grid container>    
                    <Grid item md={1} xs={2}><Button onClick={()=> { onBack() }} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                </Grid> 
                <Grid item>
                    <Iframe url={url}
                        width="100%"
                        height="620vh"
                        id="myId"
                        className="myClassname"
                        display="initial"
                        position="relative"
                        onLoad={(e)=>{checkBasicAccountPayment(e.target.contentWindow.location.href, dispatch, onSuccessRequest, onFailureRequest)}}
                    />
                </Grid>
            </Grid>
}